/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable camelcase */
// eslint-disable-next-line @byted/npcSdk/invalid-lerna-import
import jsrsasign from 'jsrsasign';
var SecurityCrypto = /** @class */ (function () {
    // private _ticket_name: string | undefined;
    function SecurityCrypto(props) {
        var _this = this;
        this.getKeys = function () {
            return { publicKey: _this._public_key, privateKey: _this._private_key };
        };
        /**
         * sign 加签数据
         * @param sign_str string  需要加签的数据
         * @returns string 加签之后的数据
         */
        this.sign = function (sign_str) {
            // console.log(this._private_key, 'private');
            var sign_key = jsrsasign.KEYUTIL.getKey(_this._private_key || '');
            // console.log(sign_key, 'sign_key');
            var sig = new jsrsasign.KJUR.crypto.Signature({
                alg: _this.cryptType === 'ECDSA' ? 'SHA256withECDSA' : 'SHA256withRSA',
            });
            sig.init(sign_key);
            var sig_data = sig.signString(sign_str);
            // console.log(sig_data, 'sig_data');
            return sig_data;
        };
        this.verify = function (sign_str, cert) {
            var sig2 = new jsrsasign.KJUR.crypto.Signature({ alg: 'SHA256withECDSA' });
            sig2.init(cert);
            var isValid = sig2.verify(sign_str);
            return isValid;
        };
        /**
         *
         * @param data need encrypt data
         */
        this.encrypt = function (data) {
            var encry_key = jsrsasign.KEYUTIL.getKey(_this._public_key || '');
            return jsrsasign.KJUR.crypto.Cipher.encrypt(data, encry_key, 'RSAOAEP256');
        };
        this.decrypt = function (data) {
            var encry_key = jsrsasign.KEYUTIL.getKey(_this._private_key || '');
            return jsrsasign.KJUR.crypto.Cipher.decrypt(data, encry_key, 'RSAOAEP256');
        };
        /**
         * 获取CSR
         * @returns csr pem
         */
        this.getCSR = function () {
            var csr = new jsrsasign.KJUR.asn1.csr.CertificationRequest({
                subject: { str: '/C=CN/CN=bd_ticket_guard' },
                sbjpubkey: _this._public_key || '',
                sigalg: _this.cryptType === 'ECDSA' ? 'SHA256withECDSA' : 'SHA256withRSA',
                extreq: [{ extname: 'subjectAltName', array: [{ dns: window.location.hostname }] }],
                sbjprvkey: _this._private_key || '',
            });
            var pem = csr.getPEM();
            return pem;
        };
        var _a = props.type, type = _a === void 0 ? 'ECDSA' : _a, privateKey = props.privateKey, publicKey = props.publicKey;
        this.cryptType = type;
        if (type === 'RSA' && publicKey && !privateKey) {
            this._public_key = publicKey;
        }
        else if (!(privateKey && publicKey)) {
            if (type === 'RSA') {
                var _b = jsrsasign.KEYUTIL.generateKeypair('RSA', 1024), prvKeyObj = _b.prvKeyObj, pubKeyObj = _b.pubKeyObj;
                this._public_key = jsrsasign.KEYUTIL.getPEM(pubKeyObj);
                this._private_key = jsrsasign.KEYUTIL.getPEM(prvKeyObj, 'PKCS8PRV');
                // console.log(this._public_key);
                // console.log(this._private_key);
            }
            else {
                var _c = jsrsasign.KEYUTIL.generateKeypair('EC', 'secp256r1'), prvKeyObj = _c.prvKeyObj, pubKeyObj = _c.pubKeyObj;
                this._public_key = jsrsasign.KEYUTIL.getPEM(pubKeyObj);
                this._private_key = jsrsasign.KEYUTIL.getPEM(prvKeyObj, 'PKCS8PRV');
                // console.log(this._public_key);
                // console.log(this._private_key);
            }
        }
        else {
            this._public_key = publicKey;
            this._private_key = privateKey;
        }
    }
    return SecurityCrypto;
}());
export default SecurityCrypto;
